namespace AgerLMS {
    export enum BadgeTypes {
        RegistrationDate = 0,
        CoursesCount = 1,
        CoursesRating = 2,
        SupportRating = 3,
        StoreSalesCount = 4
    }
    Serenity.Decorators.registerEnumType(BadgeTypes, 'AgerLMS.BadgeTypes');
}
